import { COMMON, ifyouApi, kevinAuthAPI, STORY } from 'apis/config';

export const illustApi = {
  read: (projectId: string, lang: string) =>
    ifyouApi
      .post(`${STORY}/${projectId}/ill-list`, {
        lang: lang,
      })
      .then((res) => res.data.map((v, i) => ({ ...v, key: i }))),

  detail: (projectId: string, illustId: string) =>
    ifyouApi
      .post(`${STORY}/${projectId}/ill-detail`, {
        illust_id: illustId,
        illust_type: 'illust',
      })
      .then((res) => res.data),
  // 일러스트 등록
  register: (props) =>
    ifyouApi
      .post(`${STORY}/${props.projectId}/ill-insert`, props.formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data),

  update: ({ projectId, formData }) =>
    ifyouApi
      .post(`${STORY}/${projectId}/ill-update`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data),

  // 일러스트 삭제
  delete: (props) =>
    ifyouApi
      .post(`${STORY}/${props.project_id}/ill-delete`, {
        illust_id: props.illust_id,
      })
      .then((res) => res.data),
  // live illust pair list(리소스 연결)
  fetchIllustPair: (projectId) =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'getLivePairList',
        code: 'illust',
        project_id: projectId,
      })
      .then((res) => res.data),
  // 썸네일 연결
  fetchThumbnailList: (projectId) =>
    ifyouApi
      .post(`${STORY}/${projectId}/com-design-select`, {
        design_type: 'illust_crop',
      })
      .then((res) => res.data),
  // NEW API
  illustList: (projectId) =>
    kevinAuthAPI
      .get(`/resource-manager/static/${projectId}/illust`)
      .then((res) => res.data),
  illustInsert: (projectId: string, data) =>
    kevinAuthAPI
      .post(`/resource-uploader/multi-upload/${projectId}/illust`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data)
      .catch((err) => console.log(err)),
  illustDelete: (id: string) =>
    kevinAuthAPI
      .delete(`/resource-manager/static/${id}`)
      .then((res) => res.data)
      .catch((error) => {
        console.log(error);
      }),
  illustUpdateThumbnail: (projectId: string, id: string, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return kevinAuthAPI
      .post(`/resource-manager/static-thumbnail/${projectId}/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },
  illustUpdateImage: (projectId: string, id: string, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return kevinAuthAPI
      .patch(`/resource-manager/static/${projectId}/illust/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },
  illustUpdateInfor: (projectId: string, id: string, data) =>
    kevinAuthAPI
      .put(`/resource-manager/static/${projectId}/illust/${id}`, data)
      .then((res) => res.data)
      .catch((err) => console.log(err)),
};
